import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/download/sec7_card.png'
import _imports_1 from '@/assets/img/download/sec7_phone.png'


const _hoisted_1 = { class: "max-w-4xl mx-auto flex flex-col sm:flex-row w-[896px]:px-0 px-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "lg:mt-40 mt-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium lg:my-20 my-10 mt-20 mb-10 leading-relaxed text-lg sm:text-xl sm:leading-relaxed text-center sm:text-left text-[#3E4044]" }, [
    /*#__PURE__*/_createTextVNode("나의 파충류 사육 경험을 나누고"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 다른 집사님들과 이야기해보세요.")
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "sm:-translate-x-4 sm:h-120"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleBox = _resolveComponent("TitleBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["w-full sm:w-1/2 transition-all duration-1000 opacity-0", _ctx.elClass]),
      ref: "elRef"
    }, [
      _createVNode(_component_TitleBox, {
        title: "커뮤니티",
        content1: "파충류에 관심있는 누구나",
        content2: "다른 집사님들과 이야기해보세요.",
        class: "tracking-tighter"
      }),
      _hoisted_2
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["w-full sm:w-1/2 flex flex-col justify-between transition-all duration-1000 opacity-0 mt-20 sm:mt-0 delay-300", _ctx.elClass])
    }, _hoisted_4, 2)
  ]))
}